<script setup>
import { ref } from 'vue'
import AIReportsListItem from './AIReportsListItem.vue'
import { Spinner } from '@/components/ui/spinner'

const props = defineProps({
  reports: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['delete', 'refresh', 'open'])

const handleDelete = (reportId) => {
  emit('delete', reportId)
}

const handleRefresh = () => {
  emit('refresh')
}

const handleOpen = (reportCode) => {
  emit('open', reportCode)
}
</script>

<template>
  <div>
    <!-- Loading State -->
    <div v-if="loading" class="flex items-center justify-center py-8">
      <Spinner class="h-6 w-6" />
      <span class="ml-2 text-sm text-muted-foreground">Loading reports...</span>
    </div>

    <!-- Empty State -->
    <div v-else-if="!reports || reports.length === 0" class="text-center py-8">
      <div class="text-muted-foreground">
        <p class="text-lg mb-2">No reports found</p>
        <p class="text-sm">Generate your first report to see it here</p>
      </div>
    </div>

    <!-- Reports List -->
    <div v-else>
      <AIReportsListItem
        v-for="report in reports"
        :key="report.id"
        :report="report"
        @delete="handleDelete"
      />
    </div>
  </div>
</template>
